import React, { Component } from 'react';


export default class NewsItem extends Component {

  render() {
    let { title, description, imageUrl, newsUrl, author, date, source } = this.props;

    return (
      <div className='my-3'>

        <div className="card" >
          {/* style={{ width: "25rem" }} */}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            position: 'absolute',
            right: '0'
          } }>
            <span className="position-absolute top-0 translate-middle badge rounded-pill bg-info">
              {source}
            </span>
          </div>

          <img src={!imageUrl ? "https://ichef.bbci.co.uk/news/1024/branded_news/ffc3/live/53395180-f385-11ef-bdb2-df3b1e28059d.jpg" : imageUrl} className="card-img-top" alt="" />
          <div className="card-body">
            <h5 className="card-title">{title}
              {/* <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info">
              {source}
            </span> */}
            </h5>
            <p className="card-text">{description}</p>
            <p className="card-text"><small className="text-body-secondary">
              By: {!author ? "Unknown" : author} on {new Date(date).toGMTString()}</small></p>
            <a rel="noopener noreferrer" href={newsUrl} target='_blank'
              className="btn btn-sm btn-dark">Read More</a>
          </div>
        </div>
      </div>
    )
  }
}
